import type { ServicesManager, ServiceBinding } from '@wix/services-manager/types'

export const registerServices = (
	servicesManager: ServicesManager,
	serviceProviders: Array<ServiceBinding<any, any>>
): void => {
	serviceProviders.forEach((service) => {
		if (service.definition && !servicesManager.hasService(service.definition)) {
			servicesManager.addService(service.definition, service.impl, service.config)
		}
	})
}
